module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1014-2d9bdbb6924ad295f423bebe14f5acf6.png";